import { defaultUnderlineStyle } from "@ecco/ui/css/common";
import { space } from "@ecco/ui/tokens";
import type { StyleProps } from "@ecco/ui/types";

export const checkoutStepStyle = {
    borderWidth: 1,
    borderColor: "green",
};

export const checkoutStepDisabledStyle = {
    ...checkoutStepStyle,
    borderColor: "red",
};

export const formStepStyle = {
    m: 20,
    p: 20,
    backgroundColor: "grey",
};

export const checkoutPageGridStyles = {
    gap: { base: 0, lg: space["4"] },
    templateColumns: ["100%", "100%", "100%", "8fr 4fr"],
    bg: "gray.50",
    px: ["3", "4", "6"],
    pt: ["6", "8", "12"],
    pb: "6",
    sx: {
        // Show RequiredIndicator for fields in checkout unless it's readonly
        '[role="group"]:not([data-readonly]) .chakra-form__required-indicator': {
            display: "block",
        },
    },
};

export const checkoutSupportModuleStyles = {
    "& h5": {
        fontSize: "desktopBodyTextNormal",
    },
    "& button": {
        color: "black",
        fontWeight: "bold",
        ...defaultUnderlineStyle,
    },
};

export const summaryStyles: Record<string, StyleProps> = {
    column: {
        width: {
            base: "100%",
            md: 92,
        },
        maxWidth: "100%",
    },
    summaryText: {
        fontSize: ["mobileBodyTextSmall", "mobileBodyTextSmall", "desktopBodyTextSmall"],
    },
    summaryHeadline: {
        textTransform: "uppercase",
        fontWeight: "bold",
    },
};
